module.exports = __webpack_public_path__ + "static/media/coverimg.5939fd11.jpg";